import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProgressDisplay = ({
  progress
}) => {
  if (!progress) return null;
  const {
    totalItems,
    completedItems
  } = progress;
  const itemsRemaining = totalItems - completedItems;
  if (itemsRemaining === 0) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.certificationProfile.table.awaitingCertification"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.certificationProfile.table.awaitingCertificationTooltip"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.tableColumns.itemsRemaining",
    options: {
      itemsRemaining,
      itemsTotal: totalItems
    }
  });
};
export default ProgressDisplay;